import { render, staticRenderFns } from "./newMonthlyMed.vue?vue&type=template&id=af97bac2&scoped=true"
import script from "./newMonthlyMed.vue?vue&type=script&lang=js"
export * from "./newMonthlyMed.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./newMonthlyMed.vue?vue&type=style&index=1&id=af97bac2&prod&lang=css"
import style2 from "./newMonthlyMed.vue?vue&type=style&index=2&id=af97bac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af97bac2",
  null
  
)

export default component.exports